import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertController } from '@ionic/angular';
import { Subscription, finalize } from 'rxjs';
import { LOCAL_STORAGE } from 'src/app/shared/constants/local-storage.constants';
import { CustomerInput } from 'src/app/shared/models/customer.model';
import { CustomerService } from 'src/app/shared/services/customer.service';
import { StorageService } from 'src/app/shared/services/storage.service';


@Component({
  selector: 'simpayx-manage-profile',
  templateUrl: './manage-profile.component.html',
  styleUrls: ['./manage-profile.component.scss'],
})
export class ManageProfileComponent implements OnInit {
  @ViewChild("imageInput") imageInput: ElementRef;
  profileForm: FormGroup;
  backHref: string;
  profileImage: any;
  customerDetails: CustomerInput;
  customerServiceSubscription: Subscription;
  isInvalidEmail: boolean = false;
  isInvalidName: boolean = false;
  isNameEmpty: boolean = false;
  imageUploading: boolean = false;
  editProfileImage: boolean = false;
  homePageURL: string;

  constructor(
    private storageService: StorageService,
    private customerService: CustomerService,
    private alertController: AlertController,
    private ref: ChangeDetectorRef,
    private storage: AngularFireStorage,
    private fb: FormBuilder
  ) {}

  ngOnInit() {

    this.profileForm = this.fb.group({
      name: ['', [Validators.required, Validators.pattern(/^[a-zA-Z\s]*$/)]],
      phone: [{ value: '', disabled: true }],
      emailId: ['', [Validators.required, Validators.pattern("[A-Za-z0-9._%+-]{3,}@[a-zA-Z]{3,}([.]{1}[a-zA-Z]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,})")]]
    });
    this.getCustomerDetails();
    this.getBusinessIdMerchantIdFromLocal();
  }

  populateForm() {
    if (this.customerDetails) {
      this.profileForm.patchValue({
        name: this.customerDetails.name,
        phone: this.customerDetails.phoneNumber,
        emailId: this.customerDetails.emailId
      });
    }
  }

  isFieldInvalid(field: string): boolean {
    const control = this.profileForm.get(field);
    return control && control.invalid && (control.dirty || control.touched);
  }

  getBusinessIdMerchantIdFromLocal() {
    const businessId = this.storageService.getLocalStorageData(
      LOCAL_STORAGE.BUSINESS_VALUES
    ).businessId;
    const merchantId = this.storageService.getLocalStorageData(
      LOCAL_STORAGE.BUSINESS_VALUES
    ).merchantId;
    const baseUrl = 'simpayx/logistic';
    const queryParams = `merchantId=${merchantId}&businessId=${businessId}`;
    this.backHref = `${baseUrl}?${queryParams}`;
  }

  getCustomerDetails() {
    this.customerServiceSubscription = this.customerService
      .getCustomerAsObservable()
      .subscribe((result: CustomerInput) => {
        console.log(result);
        this.customerDetails = result;
        this.populateForm();
        if (this.customerDetails?.id && this.customerDetails.profileImageUrl) {
          this.profileImage = this.customerDetails.profileImageUrl;
        } else {
          this.profileImage = './assets/icon/Avatar.png';
        }
      });
  }

  updateCustomerDetails() {
    const customerId = this.customerDetails.id;
    const updatedCustomerData = { ...this.customerDetails,...this.profileForm.value };

    if (this.profileForm.invalid) {
      return;
    }
    this.customerService.updateCustomer(customerId, updatedCustomerData)
      .subscribe({
        next: (response: any) => {
          if (response) {
            this.storageService.setLocalStorageData(
              LOCAL_STORAGE.CUSTOMER_DETAILS,
              JSON.stringify(response.data.UpdateCustomer),
            );
            this.customerService.setCustomerDetails(response.data.UpdateCustomer);
          }
          this.presentAlert('Update successful');
        },
        error: (error: any) => {
          console.error('Update failed:', error);
        }
      });
  }

  async presentAlert(message: string) {
    const alert = await this.alertController.create({
      header: 'Alert',
      message: message,
      buttons: [
        {
          text: 'OK',
          handler: () => {
            const businessId = this.storageService.getLocalStorageData(
              LOCAL_STORAGE.BUSINESS_VALUES
            ).businessId;
            const merchantId = this.storageService.getLocalStorageData(
              LOCAL_STORAGE.BUSINESS_VALUES
            ).merchantId;
            const baseUrl = 'simpayx/logistic';
            const queryParams = `merchantId=${merchantId}&businessId=${businessId}`;
            this.homePageURL = `${baseUrl}?${queryParams}`;
            window.location.href = this.homePageURL;
          },
        },
      ],

    });
    await alert.present();
  }

  enableImageEdit() {
		this.imageInput.nativeElement.click();
    this.editProfileImage = true;
	}

  processFile(imageInput: any) {
		const file: File = imageInput.files[0];

		console.log(file.name);
		const extension = file.name.split("?")[0].split(".").pop();
		let imageName = this.createImageName(extension);
		const image = new File([file], imageName, {
			type: "image/" + extension,
		});
		this.imageUploading = true;
		this.uploadImage(image, imageName);
	}

	createImageName(ex: any) {
		//user profile images created with customer id
		let userName = "";
		let userId = "";
		if (this.customerDetails.id.length <= 5) {
			userId = this.customerDetails.id;
		} else {
			userId = this.customerDetails.id.slice(-5);
		}
		if (this.customerDetails.name.length <= 5) {
			userName = this.customerDetails.name;
		} else {
			userName = this.customerDetails.id.slice(-5);
		}
		return userName + userId + "." + ex;
	}

	uploadImage(image: any, imageName: any) {
    const filePath = `ProfilePictures/${imageName}`;
    const fileRef = this.storage.ref(filePath);
    const task = this.storage.upload(filePath, image);

    task.snapshotChanges()
      .pipe(
        finalize(() => {
          fileRef.getDownloadURL().subscribe(url => {
            this.profileImage = url;
            this.imageUploading = false;
            this.customerDetails.profileImageUrl = url;
            this.updateCustomerDetails();
            console.log(this.profileImage);
            this.editProfileImage = false;
          });
        })
      )
      .subscribe();
  }


  ngOnDestroy(): void {
    if (this.customerServiceSubscription) {
      this.customerServiceSubscription.unsubscribe();
    }
  }
}